const NOW_VALUE = "$now";
var DateTimeValueType = /* @__PURE__ */ ((DateTimeValueType2) => {
  DateTimeValueType2["Relative"] = "Relative";
  DateTimeValueType2["Specific"] = "Specific";
  return DateTimeValueType2;
})(DateTimeValueType || {});
export {
  DateTimeValueType,
  NOW_VALUE
};
//# sourceMappingURL=default-values.js.map
